export const BREAKPOINTS = {
  mobile: '425px',
  tablet: '768px',
  laptop: '1025px',
  smallDesktop: '1099px',
  desktop: '1279px',
  largeDesktop: '1536px'
};
